import { render, staticRenderFns } from "./actWork.vue?vue&type=template&id=121f81f7&"
import script from "./actWork.vue?vue&type=script&lang=js&"
export * from "./actWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports